<div id="section-buttons" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Buttons</p>

    <p class="h3 m-t-20">Variants</p>

    <div class="row m-t--20">
      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnPrimary type="button" class="btn btn-primary">.btn-primary</button>

        <copy-element [html]="btnPrimary"></copy-element>
      </div>

      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnSecondary type="button" class="btn btn-secondary">.btn-secondary</button>
        <copy-element [html]="btnSecondary"></copy-element>
      </div>

      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnSecondary1 type="button" class="btn btn-secondary-1">.btn-secondary-1</button>
        <copy-element [html]="btnSecondary1"></copy-element>
      </div>

      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnSecondary2 type="button" class="btn btn-secondary-2">.btn-secondary-2</button>
        <copy-element [html]="btnSecondary2"></copy-element>
      </div>

      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnAccent1 type="button" class="btn btn-accent-1">.btn-accent-1</button>
        <copy-element [html]="btnAccent1"></copy-element>
      </div>

      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnAccent2 type="button" class="btn btn-accent-2">.btn-accent-2</button>
        <copy-element [html]="btnAccent2"></copy-element>
      </div>
    </div>

    <div class="m-t-20">
      <div class="row m-t--20">
        <div class="col-12 col-md-3 m-t-20 copy-container">
          <button #btnSuccess type="button" class="btn btn-success">.btn-success</button>
          <copy-element [html]="btnSuccess"></copy-element>
        </div>

        <div class="col-12 col-md-3 m-t-20 copy-container">
          <button #btnDanger type="button" class="btn btn-danger">.btn-danger</button>
          <copy-element [html]="btnDanger"></copy-element>
        </div>

        <div class="col-12 col-md-3 m-t-20 copy-container">
          <button #btnWarning type="button" class="btn btn-warning">.btn-warning</button>
          <copy-element [html]="btnWarning"></copy-element>
        </div>

        <div class="col-12 col-md-3 m-t-20 copy-container">
          <button #btnInfo type="button" class="btn btn-info">.btn-info</button>
          <copy-element [html]="btnInfo"></copy-element>
        </div>
      </div>
    </div>

    <div class="row m-t--20">
      <div class="col-12 m-t-20">
        <p class="h3 m-t-20">Outline</p>
      </div>
    </div>

    <div class="row m-t--20">
      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnOutlinePrimary type="button" class="btn btn-outline-primary">.btn-outline-primary</button>
        <copy-element [html]="btnOutlinePrimary"></copy-element>
      </div>

      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnOutlineSecondary type="button" class="btn btn-outline-secondary">.btn-outline-secondary</button>
        <copy-element [html]="btnOutlineSecondary"></copy-element>
      </div>

      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnOutlineSecondary1 type="button" class="btn btn-outline-secondary-1">.btn-outline-secondary-1</button>
        <copy-element [html]="btnOutlineSecondary1"></copy-element>
      </div>

      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnOutlineSecondary2 type="button" class="btn btn-outline-secondary-2">.btn-outline-secondary-2</button>
        <copy-element [html]="btnOutlineSecondary2"></copy-element>
      </div>

      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnOutlineAccent1 type="button" class="btn btn-outline-accent-1">.btn-outline-accent-1</button>
        <copy-element [html]="btnOutlineAccent1"></copy-element>
      </div>

      <div class="col-12 col-md-3 m-t-20 copy-container">
        <button #btnOutlineAccent2 type="button" class="btn btn-outline-accent-2">.btn-outline-accent-2</button>
        <copy-element [html]="btnOutlineAccent2"></copy-element>
      </div>
    </div>

    <div class="m-t-20">
      <div class="row m-t--20">
        <div class="col-12 col-md-3 m-t-20 copy-container">
          <button #btnOutlineSuccess type="button" class="btn btn-outline-success">.btn-outline-success</button>
          <copy-element [html]="btnOutlineSuccess"></copy-element>
        </div>

        <div class="col-12 col-md-3 m-t-20 copy-container">
          <button #btnOutlineDanger type="button" class="btn btn-outline-danger">.btn-outline-danger</button>
          <copy-element [html]="btnOutlineDanger"></copy-element>
        </div>

        <div class="col-12 col-md-3 m-t-20 copy-container">
          <button #btnOutlineWarning type="button" class="btn btn-outline-warning">.btn-outline-warning</button>
          <copy-element [html]="btnOutlineWarning"></copy-element>
        </div>

        <div class="col-12 col-md-3 m-t-20 copy-container">
          <button #btnOutlineInfo type="button" class="btn btn-outline-info">.btn-outline-info</button>
          <copy-element [html]="btnOutlineInfo"></copy-element>
        </div>
      </div>
    </div>
  </div>
</div>
